module.exports = __webpack_public_path__ + "static/media/slider3.f4c086d6.png";